export default __webpack_public_path__ + "static/currents-quiz-sm-2779031ee1bd75f58566456fe5cbb4e0.mp4";